import axios from 'axios'
import Vue from 'vue'
import Store from '@/store';
import Router from '@/router';
import {
	Loading,
	MessageBox
} from 'element-ui'
import {
	userLogout,
} from "@/http/api/index";

//创建axios
const service = axios.create({
	// baseURL: process.env.NODE_ENV === "development" ? '/testapi' : process.env.VUE_APP_BASE_URL,
	baseURL: process.env.VUE_APP_BASE_URL,
	timeout: 60000,
	withCredentials: true
})

var tokenPromise = null
var loadingCount = 0; //打开 laoding  的个数
var loading;
var showMessageCount = 0;
var notGetToken = ['https://user.tsgyun.com/user/get-login-status', '/reg/send_code', '/reg/up-cur-user-talk',
	'/reg/reg-talk', '/reg/get-reg-self-info-list-talk-phone', '/reg/del-reg-self-info-talk',
	'/index/index-tools', '/index/index-art', '/index/index-online-lesson', '/index/index-banner', '/login/loginout'
]
var notMessage = ['https://user.tsgyun.com/user/get-login-status', '/login/loginout']   // 不提示消息
// 不验证登录页面
var notVerifyLoginPage = ['#/youthTalentProgramP', '#/youthTalentProgramM']

// loading开始 方法
function startLoading() {
	loadingCount++;
	loading = Loading.service({
		lock: true,
		text: '拼命加载中...',
		spinner: 'el-icon-loading', // 自定义图标
		background: 'rgba(0, 0, 0, 0.7)'
	})
}

// loading结束 方法
function loadingClose() {
	loadingCount--;
	loading.close()
}

function logout() {
	// 项目内退出
	userLogout().then((res) => {}).catch((error) => {
		if(Router.currentRoute.name == 'NoPermission') {
			window.location.href = '/';
		}
	});
}
localStorage.removeItem('token')
async function getToken(refresh = false) {
	if (tokenPromise == null || refresh) {
		tokenPromise = new Promise((resolve, reject) => {
			service.get('https://user.tsgyun.com/user/get-login-status', {
				headers: {
					Token: sessionStorage.getItem('token')
				}
			}).then(res => {
				if (res.data.token) {
					sessionStorage.setItem('token', res.data.token)
					resolve(res.data.token)
				} else {
					sessionStorage.removeItem('token')
					logout()
					Router.push('/')
				}
			}).catch((err) => {
				if(notVerifyLoginPage.indexOf(window.location.hash) == -1) Router.push('/')
				sessionStorage.removeItem('token')
				logout()
			})
		})
	}
	return tokenPromise
}

// 请求拦截器
service.interceptors.request.use(async (config) => {
	config.headers['Content-Type'] = 'application/json;charset=utf-8'
	config.data = JSON.stringify(config.data)

	if (notGetToken.indexOf(config.url) == -1) {
		var token = await getToken()
		config.headers.Token = token;
	}

	if (config.requestLoading) {
		startLoading();
	}
	return config
}, error => {
	Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use((res) => {
	// console.log(res);
	if (res.config.requestLoading) {
		loadingClose();
	}
	
	// 不做判断,直接返回
	if(res.config.isBack) return res.data

	// 未登录
	if (res.data.code == 1 || res.data.code == 4) {
		// console.log('未登录')
		Store.commit('setUserInfo', null)
		// 初次访问不提示消息
		if(!sessionStorage.getItem('token') && notMessage.indexOf(res.config.url) != -1) {
			sessionStorage.removeItem('token')
			return Promise.reject(res)
		}
		// 登录信息已过期
		sessionStorage.removeItem('token')
		if (res.config.url == '/reg/get-cur-user-talk') {
			MessageBox('您未进行登录或登录信息已过期, 去登录?', '提示', {
				type: 'warning'
			}).then(() => {
				var url = `https://user.tsgyun.com/user/ssologin?sid=${process.env.VUE_APP_SID}&returnUrl=` + encodeURIComponent(window.location.href)
				window.open(url, '_self')
			}).catch(() => {});
		} else if (showMessageCount == 0) {
			Vue.$message.error('您未进行登录或登录信息已过期')
			showMessageCount++
		}

		setTimeout(() => {
			showMessageCount = 0
		}, 3000)

		return Promise.reject(res)
	}
	// 无权限
	if (res.data.code == 2) {
		Vue.$message.error(res.data.msg)
		return Promise.reject(res)
	}

	if (res.data.code !== 0) {
		Vue.$message.error(res.data.msg)
		return Promise.reject(res)
	}
	return res.data
}, (error) => {
	if (error.config.requestLoading) {
		loadingClose();
	}
	return Promise.reject(error)
})

export default service